import { transitionPaymentsForm } from '../../../actions/travelUg/payments';
import { getPaymentsForm } from '../../../selectors/travelUg/payments';
import { FIELD_STATUS } from '../../../reducers/status';

export const paymentsFormRules = (store, next, action) => {
    const result = next(action);
    const paymentsForm = getPaymentsForm(store.getState());
    const paymentsFormValid = validatePaymentsFormDetails(paymentsForm);
    const paymentsFormAction = paymentsFormValid
        ? transitionPaymentsForm.formValid()
        : transitionPaymentsForm.formInvalid();
    store.dispatch(paymentsFormAction);

    return result;
};

const validatePaymentsFormDetails = (formFields) => {
    return (
        formFields?.phoneNumber?.status === FIELD_STATUS.VALID &&
        formFields?.terms?.status === FIELD_STATUS.VALID &&
        formFields?.networkProvider?.status === FIELD_STATUS.VALID
    );
};
